import validate from "/cre-app/node_modules/nuxt/dist/pages/runtime/validate.js";
import partner_45article_45global from "/cre-app/client/middleware/partner-article.global.ts";
import manifest_45route_45rule from "/cre-app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  partner_45article_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}